import React, { useState, useEffect } from "react";
import { useDispatch, UseDispatch, useSelector } from "react-redux";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import {
  Port2Status,
  Port2Error,
  Port2UpdatedTime,
  Port2Loading,
  fetchAsyncPort2Info,
} from "./Port2Slice";

import { PeriodType } from "./Port2View";
//propsのinterface
interface Port2Props {
  period: PeriodType;
}

const Port2Graph = ({ period }: Port2Props) => {
  //storeにアクセス
  //データ
  const [data, setData] = useState<string[]>();
  const Port2InfoData = useSelector(Port2Status);

  const dispatch = useDispatch();

  //periodの状態に応じてグラフを切り替える
  useEffect(() => {
    if (Port2InfoData) {
      if (period === "累計") {
        setData(Port2InfoData.total);
      } else if (period === "今月") {
        setData(Port2InfoData.this_month);
      } else if (period === "先月") {
        setData(Port2InfoData.last_month);
      }
    }
  }, [period, Port2InfoData]);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncPort2Info());

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncPort2Info());
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch]); // 依存配列にdispatchを含める

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        layout="vertical"
        width={500}
        height={300}
        data={data}
        margin={{
          top: 40,
          right: 10,
          left: 140,
          bottom: 5,
        }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="返却件数" type="number" />
        <XAxis dataKey="貸出件数" type="number" />
        <YAxis
          dataKey="port_name"
          type="category"
          // onClick={(e) => setPortHandle(e)}
        />
        <Tooltip />
        <Legend />
        <Line dataKey="貸出件数" stroke="#8884d8" />
        <Line dataKey="返却件数" stroke="#82ca9d" />
      </LineChart>
    </ResponsiveContainer>
  );
};
export default Port2Graph;
